/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Offer_FailedInputs */

const en_premium_offer_failed = /** @type {(inputs: Premium_Offer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load our plans just now. Reload the page to try again.`)
};

const es_premium_offer_failed = /** @type {(inputs: Premium_Offer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos cargar nuestros planes en este momento. Vuelve a cargar la página para intentarlo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We couldn't load our plans just now. Reload the page to try again." |
*
* @param {Premium_Offer_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_offer_failed = /** @type {((inputs?: Premium_Offer_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Offer_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_offer_failed(inputs)
	return en_premium_offer_failed(inputs)
});